module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/53d7e392dc0f35620dc77321555a936e.gif";